import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FxDetailStatusComponent } from './fx-detail-status.component';
import {DwDocumentModule, FrameworkUIModule} from '@webdpt/framework';
import {FxDapModule} from '../../fx-http-client';
import {PipesModule} from '../pipe/pipes.module';
import {MatAutocompleteModule} from '@angular/material';

@NgModule({
  declarations: [FxDetailStatusComponent],
  imports: [
    CommonModule,
    FrameworkUIModule,
    FxDapModule,
    DwDocumentModule,
    PipesModule,
    MatAutocompleteModule
  ],
  exports: [
    FxDetailStatusComponent
  ],
  entryComponents: [
    FxDetailStatusComponent
  ]
})
export class FxDetailStatusModule { }
